module.exports = __webpack_public_path__ + "img/goal_pc-min.6ff98ffe.jpg";